import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { queryKeys } from './queryKeys';

interface FetcherParams {
  clientId: string;
  id: string;
}

const deleteInsurance = ({ clientId, id }: FetcherParams) => {
  return authFetch('/Consumer/AccountUpdate/DeleteAccount', {
    method: 'POST',
    ...httpBodyOptions({ clientId, AccountId: id }),
  });
};

interface Params {
  clientId: string;
}

export const useDeleteInsuranceMutation = ({ clientId }: Params) => {
  const queryClient = useQueryClient();

  return useMutation(deleteInsurance, {
    async onSuccess() {
      await queryClient.refetchQueries(queryKeys.insurance(clientId));
    },
  });
};
